module.exports = __webpack_public_path__ + "img/Y1My.e6360261.gif";